import { FeatureState, FeatureResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getFeatures } from './feature.services';

export const initialState: FeatureState = {
    data: {} as FeatureResponse,
    status: "loading",
    error: {}
}

export const FeatureSlice = createSlice({
    name: 'features',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getFeatures.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getFeatures.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getFeatures.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const FeatureReducer = FeatureSlice.reducer